import { Service } from "app/config/service";
import API_ROUTES from "app/constants/routes/api";
import { getItem } from "app/utils/session";
import { setNotificationMessage } from "../home/action";
import {
    setStateData,
    setCityData,
    setPinCodeData,
    setCumulationData
} from './action'
import {
    GET_COMPLETE_STATE_DATA,
    GET_CUMULATION_DATA
} from './types'

const { createLogic } = require("redux-logic");

const getMapStateData = createLogic({
    type: GET_COMPLETE_STATE_DATA,
    latest: true,
    process({ action }, dispatch, done) {
        const authToken = getItem("token");
        const payload = { authToken: authToken ? authToken : "", type: action.payload?.type, userId: action.payload.userId, state: "", city: "" };
        Service({
            method: "post",
            url: API_ROUTES.GET_STATE_CITY_PIN,
            data: payload,
        })
            .then((res) => {
                if (res?.data?.data) {
                    switch (action.payload?.type) {
                        case 'COMPLETE_STATE':
                            dispatch(setStateData(res?.data?.data))
                            break;
                        case 'COMPLETE_CITY':
                            dispatch(setCityData(res?.data?.data))
                            break;
                        case 'COMPLETE_PINCODE':
                            dispatch(setPinCodeData(res?.data?.data))
                            break;

                        default:
                            break;
                    }
                }
                done();
            })
            .catch((err) => {
                dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
                done();
            });
    },
});

const getCumulationDataLogic = createLogic({
    type: GET_CUMULATION_DATA,
    latest: true,
    process({ action }, dispatch, done) {
        const authToken = getItem("token");
        Service({
            method: "GET",
            url: API_ROUTES.CUMULATION_REPORT,
            header: { AUTH_TOKEN: authToken },
            data: { authToken }
        })
            .then((res) => {
                if (res?.data?.data) {
                    dispatch(setCumulationData(res?.data?.data))
                }
                done();
            })
            .catch((err) => {
                dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
                done();
            });
    },
});

export default [
    getMapStateData,
    getCumulationDataLogic
];



